import setIn from 'transmute/setIn';
import { UPDATE_DEAL, SAVE_DEALS_UPDATES, CANCEL_DEALS_UPDATES } from '../actions/ActionTypes';
const initialState = {};
export default function stagedDealsUpdates(state = initialState, action) {
  switch (action.type) {
    case UPDATE_DEAL:
      {
        const {
          payload
        } = action;
        const newStagedUpdates = setIn([payload.dealId, payload.property], payload.value, state);
        return newStagedUpdates;
      }
    case SAVE_DEALS_UPDATES:
      return {};
    case CANCEL_DEALS_UPDATES:
      return {};
    default:
      return state;
  }
}